<template>
  <main class="mine-page">
    <section class="mine-hero">
      <button class="mine-hero__settings" type="button" @click="open('/Setting')" aria-label="Settings"><van-icon name="setting-o" /></button>
      <button class="mine-hero__user" type="button" @click="open('/Infomation')">
        <img class="mine-hero__avatar" src="/img/mine/avatar.png?v=20260924" :alt="$t('setting.avatar')">
        <span>
          <strong>{{ userInfo.username || $t('frontend.account.login_register') }}</strong>
          <i></i>
        </span>
      </button>
    </section>

    <section class="mine-summary">
      <div><span>{{ $t('frontend.account.account_point') }}</span><strong>{{ balance }}</strong></div>
      <div><span>{{ $t('frontend.account.credit_score') }}</span><strong>{{ credit }}</strong></div>
    </section>

    <section class="mine-actions">
      <button class="mine-actions__row" type="button" @click="withdraw"><van-icon name="cash-back-record" /><span>{{ $t('frontend.account.mine_withdraw') }}</span><van-icon name="arrow" /></button>
      <button class="mine-actions__row" type="button" @click="open('/WithdrawRecord')"><span>{{ $t('frontend.account.withdrawal_records') }}</span><van-icon name="arrow" /></button>
      <button class="mine-actions__row" type="button" @click="open('/VoteRecord')"><span>{{ $t('reservation.vote_record') }}</span><van-icon name="arrow" /></button>
    </section>

    <button class="mine-logout" type="button" @click="logout">{{ $t('frontend.account.mine_logout') }}</button>
    <p v-if="error" class="mine-error" role="alert">{{ error }}</p>
  </main>
</template>
<script>
import { assertResponse, displayNumber } from "../../common/reference";
import { clearSession } from "../../common/language";
export default {
  data: () => ({
    loading: false, error: "", userInfo: {},
  }),
  computed: {
    balance() { return displayNumber(this.userInfo.money); },
    totalPoints() { return displayNumber(this.userInfo.total_points); },
    credit() { return displayNumber(this.userInfo.credit); },
  },
  methods: {
    open(path) { this.$router.push(localStorage.getItem("token") ? path : "/Login"); },
    withdraw() { this.open("/Withdraw"); },
    async load() {
      if (!localStorage.getItem("token")) return this.$router.push("/Login");
      if (this.loading) return;
      this.loading = true; this.error = "";
      try {
        const response = await this.$http({ method: "get", url: "user_info" });
        if (Number(response.code) === 401) { this.logout(); return; }
        const data = assertResponse(response);
        if (data.status !== undefined && Number(data.status) !== 1) { this.logout(); return; }
        this.userInfo = data;
        this.$store.commit("setUserInfoValue", data);
      } catch (error) { this.error = error.message || this.$t('frontend.account.load_failed'); }
      finally { this.loading = false; }
    },
    logout() { clearSession(); this.$store.commit("setUserInfoValue", {}); this.$router.push("/Login"); }
  },
  created() { if (localStorage.getItem("token")) this.load(); }
};
</script>

<style scoped>
.mine-page {
  min-height: 100vh;
  padding-bottom: calc(4.4rem + env(safe-area-inset-bottom));
  background: #f3f3f6;
}

.mine-hero {
  position: relative;
  height: 8.75rem;
  padding: 2.65rem 0.7rem 0;
  color: #fff;
  background: linear-gradient(135deg, #8454bf, #8c59bd);
}

.mine-hero__settings {
  position: absolute;
  top: 0.55rem;
  left: 0.55rem;
  border: 0;
  padding: 0;
  color: #fff;
  background: transparent;
  font-size: 1.25rem;
}

.mine-hero__user {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  color: #fff;
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
}

.mine-hero__avatar {
  width: 4.15rem;
  height: 4.15rem;
  object-fit: cover;
  border-radius: 50%;
  background: #fff;
}

.mine-hero__user strong {
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
}

.mine-hero__user i {
  display: block;
  width: 4.8rem;
  height: 0.18rem;
  margin-top: 0.32rem;
  border-radius: 1rem;
  background: #fff;
}

.mine-summary {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  min-height: 3.82rem;
  margin: -1.18rem 0.5rem 0;
  overflow: hidden;
  border-radius: 0.42rem;
  background: #fff;
  box-shadow: 0 0.12rem 0.35rem rgba(44, 37, 63, 0.12);
}

.mine-summary div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  min-width: 0;
}

.mine-summary div + div { border-left: 0.04rem solid #eeeef2; }
.mine-summary span { color: #252039; font-size: 0.7rem; }
.mine-summary strong { color: #8c57c5; font-size: 0.88rem; }

.mine-actions {
  margin: 0.52rem 0.5rem 0;
  overflow: hidden;
  border-radius: 0.4rem;
  background: #fff;
  box-shadow: 0 0.1rem 0.28rem rgba(44, 37, 63, 0.1);
}

.mine-actions__row {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 2.28rem;
  padding: 0 0.65rem;
  color: #36284a;
  border: 0;
  border-bottom: 0.04rem solid #f0eff3;
  background: #fff;
  font-size: 0.75rem;
  text-align: left;
}

.mine-actions__row:last-child { border-bottom: 0; }
.mine-actions__row > .van-icon:first-child { margin-right: 0.45rem; color: #873eb2; font-size: 0.82rem; }
.mine-actions__row span { flex: 1; }
.mine-actions__row > .van-icon:last-child { color: #cbc7d1; font-size: 0.8rem; }

.mine-logout {
  display: block;
  width: 58%;
  height: 1.62rem;
  margin: 0.82rem auto 0;
  border: 0;
  border-radius: 999px;
  color: #fff;
  background: #8b57c2;
  font-size: 0.8rem;
  font-weight: 700;
}

.mine-error {
  margin: 0.65rem;
  color: #ae526d;
  font-size: 0.75rem;
  text-align: center;
}
</style>
